import classNames from 'classnames'

import { FloatingTooltip } from '../Floating'
import { Tag, TAG_APPEARANCE } from '../Tag'

import {
  LABEL_DEFAULT_SIZE,
  LABEL_ICON_COLOR,
  LABEL_QA_CONTEXT,
  LABEL_TEXT_COLOR,
} from './Label.constants'
import { isLabelCompactSize } from './Label.utils'

import * as styles from './Label.module.css'

function Label({
  backgroundColor,
  className,
  height = LABEL_DEFAULT_SIZE,
  qaName,
  removeTooltipKey,
  showTooltip = true,
  text,
  onClick,
  onRemove,
}) {
  return isLabelCompactSize(height) ? (
    <FloatingTooltip content={text}>
      <span
        className={classNames(styles.compactLabel, className)}
        style={{ '--bg-color': backgroundColor }}
      />
    </FloatingTooltip>
  ) : (
    <Tag
      appearance={TAG_APPEARANCE.filled}
      backgroundColor={backgroundColor}
      className={classNames(styles.label, className)}
      height={height}
      qaContext={LABEL_QA_CONTEXT}
      qaName={qaName}
      removeIconColor={LABEL_ICON_COLOR}
      removeTooltipKey={removeTooltipKey}
      text={text}
      textColor={LABEL_TEXT_COLOR}
      withTooltip={showTooltip}
      onClick={onClick}
      onRemove={onRemove}
    />
  )
}

export default Label
